<template>
  <span :class="['spinner-border', { 'spinner-border-sm': small }]"
        :role="label ? 'status' : null"
        :aria-hidden="label ? null : 'true'"><span v-if="label" class="sr-only">{{ label }}</span></span>
</template>

<script setup>
// Replaces bootstrap-vue's <b-spinner> with the same markup (only the props the app uses).
defineOptions({
  name: 'BSpinner',
})

defineProps({
  label: {
    type: String,
    default: null
  },
  small: {
    type: Boolean,
    default: false
  }
})
</script>
